import styled from 'styled-components';

export const Wrapper = styled.div<{ isEmpty: boolean }>`
  // TODO: do some nice styling for is empty
  /* ${({ isEmpty }) => (isEmpty ? '' : '')} */
  flex: 1 1 100%;
  cursor: move;
`;
